module.exports = __webpack_public_path__ + "media/images/lb/689-25ede385d0d2fb39ae01ac26007e8ee3.svg";